import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import EPPreviewDevices from 'editor-components/preview/EPPreviewDevices';
import { usePreviewControls } from './hooks/usePreviewControls';
import PreviewControls from './PreviewControls';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullPagePreviewModal = ({
  basePreviewUrl,
  onClose,
  onDeviceChange,
  onUrlChange,
  previewLastSynced = '',
  previewPageOptions = [],
  showPreviewPages = false,
  warningComponent
}) => {
  const {
    formattedPreviewUrl,
    handleDeviceChange,
    handleUrlChange,
    previewDevice,
    previewUrl
  } = usePreviewControls({
    basePreviewUrl,
    onDeviceChange,
    onUrlChange
  });
  return /*#__PURE__*/_jsx(Modal, {
    use: "fullscreen",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(View, {
        borderBlockEndColor: "border-core-subtle",
        borderBlockEndWidth: "200",
        borderBlockEndStyle: "solid",
        position: "relative",
        boxShadow: "100",
        flex: "0",
        children: /*#__PURE__*/_jsxs(ToolBar, {
          use: "tabs",
          paddingInline: "600",
          paddingBlock: "400",
          children: [/*#__PURE__*/_jsx(ToolBarGroup, {
            minWidth: "33%",
            children: /*#__PURE__*/_jsx(BackButton, {
              children: /*#__PURE__*/_jsx(Link, {
                onClick: onClose,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "fullPreview.back"
                })
              })
            })
          }), /*#__PURE__*/_jsx(ToolBarGroup, {}), /*#__PURE__*/_jsx(ToolBarGroup, {
            minWidth: "33%",
            children: /*#__PURE__*/_jsx(Link, {
              external: true,
              href: formattedPreviewUrl,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "fullPreview.openInNewWindow"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(View, {
        flex: "1",
        overflowY: "auto",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          blockSize: "100%",
          children: [/*#__PURE__*/_jsx(View, {
            flex: "0",
            children: /*#__PURE__*/_jsx(PreviewControls, {
              handleDeviceChange: handleDeviceChange,
              handleUrlChange: handleUrlChange,
              previewDevice: previewDevice,
              previewPageOptions: previewPageOptions,
              previewUrl: previewUrl,
              showPreviewPages: showPreviewPages,
              warningComponent: warningComponent
            })
          }), /*#__PURE__*/_jsx(View, {
            flex: "1",
            children: /*#__PURE__*/_jsx(EPPreviewDevices, {
              // Passing in last modified to trigger re-render to keep preview in sync
              devices: [previewDevice],
              previewUrl: formattedPreviewUrl,
              getDeviceStyles: device => {
                if (device !== 'desktop') {
                  return {};
                }
                return {
                  margin: '0',
                  marginBlockEnd: '0',
                  maxInlineSize: '75%',
                  inlineSize: '75%',
                  blockSize: '90%'
                };
              }
            }, previewLastSynced)
          })]
        })
      })]
    })
  });
};
export default FullPagePreviewModal;